export const IMPORT_TASKS_CSV = "/game/importTasksCsv";
export const CONTACT_FORM_SEND = "/contact/send";